export default [
  {
    path: "/courses",
    name: "courses",
    component: () => import("@/views/pages/courses/Courses.vue"),
    meta: {
      hasPermission: true,

      pageTitle: "دوره ها",
      breadcrumb: [
        {
          text: "دوره ها",
          active: true,
        },
      ],
    },
  },
  {
    path: "/courses/add",
    name: "add-course",
    component: () => import("@/views/pages/courses/course-form/courseForm.vue"),
    meta: {
      hasPermission: true,

      pageTitle: "اضافه کردن دوره",
      breadcrumb: [
        {
          text: "دوره ها",
          to: "/courses",
        },
        {
          text: "اضافه کردن دوره",
          active: true,
        },
      ],
    },
  },
  {
    path: "/courses/:id/edit",
    name: "edit-course",
    component: () => import("@/views/pages/courses/course-form/courseForm.vue"),
    meta: {
      hasPermission: true,
      pageTitle: "ویرایش دوره",
      breadcrumb: [
        {
          text: "دوره ها",
          to: "/courses",
        },
        {
          text: "ویرایش دوره",
          active: true,
        },
      ],
    },
  },
  {
    path: "/courses/:id",
    component: () => import("@/views/pages/courses/show-course/ShowCourse.vue"),
    children: [
      {
        path: "",
        name: "show-course",
        component: () =>
          import(
            "@/views/pages/courses/show-course/course-content/CourseContent.vue"
          ),
        meta: {
          notNeedLogin: true,

          pageTitle: "جزئیات دوره",
          breadcrumb: [
            {
              text: "دوره ها",
              to: "/courses",
            },
            {
              hasId: true,
              text: "جزئیات دوره",
              active: true,
            },
          ],
        },
      },
      {

        path: "sessions/:session_id",
        name: "show-session-course",
        component: () =>
          import(
            "@/views/pages/courses/show-course/session-content/SessionContent.vue"
          ),
        meta: {
          notNeedLogin: true,
          pageTitle: "جزئیات جلسه",
          breadcrumb: [
            {
              text: "دوره ها",
              to: "/courses",
            },
            {
              hasId: true,
              text: "جزئیات جلسه",
              active: true,
            },
          ],
        },
      },
    ],
  },
  {
    path: "/courses/:id/students",
    name: "students-course",
    component: () => import("@/views/pages/users/Users.vue"),
    meta: {
      hasPermission: true,
      pageTitle: "کاربران دوره",
      breadcrumb: [
        {
          text: "دوره ها",
          to: "/courses",
        },
        {
          hasId: true,
          text: "کاربران دوره",
          active: true,
        },
      ],
    },
  },
  {
    path: "/courses/:id/sessions",
    name: "show-sessions-with-exercise",
    component: () => import("@/views/pages/sessions/Sessions.vue"),
    meta: {
      pageTitle: "جلسات دوره",
      breadcrumb: [
        {
          text: "دوره ها",
          to: "/courses",
        },
        {
          hasId: true,
          text: "جلسات دوره ",
          active: true,
        },
      ],
    },
  },
];
